import { PDFViewer } from '@react-pdf/renderer'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Spinner, Label } from "asocomponents"
import LiquidacionService from '../../../../../modules/Liquidacion/application/LiquidacionService'
import ComprobanteTransferencia from './ComprobanteTransferencia'

export default function VisorPDFComprobanteTransferencia() {

  const { idLiquidacion,nroFactura, nroGestion } = useParams()
  const [isLoading, setIsLoading] = useState(true)
  const [datosComprobante, setDatosComprobante] = useState()
  //#endregion

  //#region funciones

  const cargarDatosComprobante = async (nroGestion) => {
    const liquidacionService = new LiquidacionService()
    const resultComprobante = await liquidacionService.obtenerComprobante(idLiquidacion,nroGestion, nroFactura !== 'null' ? "S" : "N")
    setDatosComprobante(resultComprobante)

  }
  //#endregion

  //#region useEffect
  useEffect(() => {
    const cargarDatos = async () => {
      setIsLoading(true)
      await cargarDatosComprobante(nroGestion)
      setIsLoading(false)
    };

    cargarDatos()
  }, [])

  //#endregion

  if (isLoading) {
    return <Spinner color="red" size="50" />
  }

  return (
    <div id='root'>
      {datosComprobante ?
        <PDFViewer width={600} height={500}>
          <ComprobanteTransferencia datosImpresion={datosComprobante} />
        </PDFViewer>
        :
        <Label texto="NO SE PUDO GENERAR EL COMPROBANTE. PROBABLEMENTE EL PAGO SE EMITIÓ EL DÍA DE LA CONSULTA. INTENTAR MAÑANA NUEVAMENTE Y DE PERSISITIR EL ERROR, CONTACTARSE CON SU REFERENTE ADMINISTRATIVO" color="text-asociart-intense"/>
      }
    </div>
  )
}
